export default __webpack_public_path__ + "static/media/applause.c327d037.mp3";